import z from 'zod/v4';

// Matches the pulumi env names + dev
const ProdEnv = z.enum(['dev', 'staging', 'prod', 'ci']);
type ProdEnv = z.infer<typeof ProdEnv>;

export type Config = {
  rawBackendUrl: string;
  backendUrl: string;
  consumerAppUrl: string;
  cognito: {
    userPoolId?: string;
    clientId?: string;
  };
  useCognito: boolean;
  isProduction: boolean;
  prodEnv?: ProdEnv;
  sentryDns?: string;
  useDemoPrefillVehicle: boolean;
};

const config: Config = {
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID
  },
  useCognito:
    Boolean(import.meta.env.VITE_COGNITO_CLIENT_ID) &&
    Boolean(import.meta.env.VITE_COGNITO_USER_POOL_ID),
  prodEnv: ProdEnv.safeParse(import.meta.env.VITE_PROD_ENV).data ?? undefined,

  // Sentry
  sentryDns: import.meta.env.VITE_SENTRY_DNS,

  useDemoPrefillVehicle: import.meta.env.VITE_DEMO_PREFILL_VEHICLE === 'TRUE',

  rawBackendUrl: import.meta.env.VITE_BACKEND_URL ?? 'http://127.0.0.1:3000',
  backendUrl: import.meta.env.VITE_BACKEND_URL
    ? `${import.meta.env.VITE_BACKEND_URL}/graphql`
    : 'http://127.0.0.1:3000/graphql',
  consumerAppUrl:
    import.meta.env.VITE_CONSUMER_APP_URL ?? 'http://localhost:5173/',
  isProduction: import.meta.env.MODE === 'production'
};

export default config;
